import i18n from '@/i18n';

/** Qo'shimcha oylik daromad manbalari (O'zbekiston uchun) */
export interface IncomeSource {
  code: string;
  label: string;
}

export const INCOME_SOURCES: IncomeSource[] = [
  { code: 'tomorqa_meva', get label() { return i18n.t('misc_income.s_tomorqa_meva'); } },
  { code: 'tomorqa_sabzavot', get label() { return i18n.t('misc_income.s_tomorqa_sabzavot'); } },
  { code: 'chorva_mol', get label() { return i18n.t('misc_income.s_chorva_mol'); } },
  { code: 'chorva_qoy', get label() { return i18n.t('misc_income.s_chorva_qoy'); } },
  { code: 'parrandachilik', get label() { return i18n.t('misc_income.s_parrandachilik'); } },
  { code: 'asalarichilik', get label() { return i18n.t('misc_income.s_asalarichilik'); } },
  { code: 'issiqxona', get label() { return i18n.t('misc_income.s_issiqxona'); } },
  { code: 'ijara_tijorat', get label() { return i18n.t('misc_income.s_ijara_tijorat'); } },
  { code: 'ijara_uy_joy', get label() { return i18n.t('misc_income.s_ijara_uy_joy'); } },
  { code: 'ijara_avto', get label() { return i18n.t('misc_income.s_ijara_avto'); } },
  { code: 'ijara_texnika', get label() { return i18n.t('misc_income.s_ijara_texnika'); } },
  { code: 'taksi_aholi', get label() { return i18n.t('misc_income.s_taksi_aholi'); } },
  { code: 'taksi_yuk', get label() { return i18n.t('misc_income.s_taksi_yuk'); } },
  { code: 'kunlik_ishlar', get label() { return i18n.t('misc_income.s_kunlik_ishlar'); } },
  { code: 'ustachilik', get label() { return i18n.t('misc_income.s_ustachilik'); } },
  { code: 'repetitor', get label() { return i18n.t('misc_income.s_repetitor'); } },
  { code: 'tikuvchilik', get label() { return i18n.t('misc_income.s_tikuvchilik'); } },
  { code: 'sartaroshlik', get label() { return i18n.t('misc_income.s_sartaroshlik'); } },
  { code: 'non_oshxona', get label() { return i18n.t('misc_income.s_non_oshxona'); } },
  { code: 'kichik_savdo', get label() { return i18n.t('misc_income.s_kichik_savdo'); } },
  { code: 'onlayn_savdo', get label() { return i18n.t('misc_income.s_onlayn_savdo'); } },
  { code: 'freelance', get label() { return i18n.t('misc_income.s_freelance'); } },
  { code: 'xorij_otkazma', get label() { return i18n.t('misc_income.s_xorij_otkazma'); } },
  { code: 'nafaqa', get label() { return i18n.t('misc_income.s_nafaqa'); } },
  { code: 'boshqa', get label() { return i18n.t('misc_income.s_boshqa'); } },
];

export function incomeSourceLabel(code: string, lng?: string): string {
  if (lng && INCOME_SOURCES.some(s => s.code === code)) return i18n.t(`misc_income.s_${code}`, { lng });
  return INCOME_SOURCES.find(s => s.code === code)?.label ?? code;
}

export interface IncomeRow {
  source_code: string;
  monthly_amount: string;
  note: string;
}

export const emptyIncomeRow = (): IncomeRow => ({ source_code: '', monthly_amount: '', note: '' });

/**
 * T224: the bank reads the salary itself and ignores these rows, but the step is kept (regulatory) — the first row is
 * pre-filled ("Boshqa", 10 000, a default note) so the cashier can pass the step at once.
 */
export const defaultIncomeRow = (): IncomeRow => ({
  source_code: 'boshqa',
  monthly_amount: '10000',
  note: i18n.t('loan_limit.income_default_note'),
});

/** Satrlar to'g'ri to'ldirilganini tekshiradi */
export function validateIncomeRows(rows: IncomeRow[]): { valid: boolean; error: string } {
  if (!rows.length) return { valid: false, error: i18n.t('misc_income.min_one') };
  for (const r of rows) {
    if (!r.source_code) return { valid: false, error: i18n.t('misc_income.pick_type') };
    const amount = Number(String(r.monthly_amount).replace(/\s/g, ''));
    if (!amount || amount <= 0) return { valid: false, error: i18n.t('misc_income.amount') };
    if (r.source_code === 'boshqa' && !r.note.trim()) {
      return { valid: false, error: i18n.t('misc_income.note_required') };
    }
  }
  return { valid: true, error: '' };
}

export function incomeTotal(rows: IncomeRow[]): number {
  return rows.reduce((s, r) => s + (Number(String(r.monthly_amount).replace(/\s/g, '')) || 0), 0);
}

/** Backendga (Loan Manager) yuboriladigan ko'rinish */
export function incomesPayload(rows: IncomeRow[]) {
  return rows.map(r => ({
    source_code: r.source_code,
    source_label: incomeSourceLabel(r.source_code, 'uz'),
    monthly_amount: Number(String(r.monthly_amount).replace(/\s/g, '')) || 0,
    note: r.note.trim(),
  }));
}
